import React, { useState, useEffect } from 'react'
import Creatable from 'react-select/creatable'
import { InputGroup, InputGroupText, Input, } from 'reactstrap';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        color: state.isSelected ? 'red' : 'blue',
        padding: 20
    })
}

const AdresWithList = ({ companyNameFirma, setCompanyNameFirma, kontaktName, setKontaktName, plz, setPLZ, streetAndNr, setStreetAndNr, adresszusatz, setAdresszusatz, länderkürzel, setLänderkürzel, state, setState, city, setCity, tel, setTel }) => {

    const [nameValue, setNameValue] = useState('')
    //const [companyNameFirma, setCompanyNameFirma] = useState('')
    //const [kontaktName, setKontaktName] = useState('')
    //const [plz, setPLZ] = useState('')
    //const [streetAndNr, setStreetAndNr] = useState('')
    //const [adresszusatz, setAdresszusatz] = useState('')
    //const [länderkürzel, setLänderkürzel] = useState('')
    //const [state, setState] = useState('')
    //const [city, setCity] = useState('')
    //const [tel, setTel] = useState('')

    const handleNameChange = (value) => {
        setNameValue(value)
        namesInfo.forEach((element, index) => {
            if (value) {
                /*eslint-disable */
                if (value.label.split(" /", 1) == element.companyName) {
                    /*eslint-enable */
                    setCompanyNameFirma(element.companyName);
                    setKontaktName(element.firstName + ' ' + element.lastName);
                    setPLZ(element.address.postalCode);
                    setStreetAndNr(element.address.addressLine1);
                    setAdresszusatz(element.address.addressLine2);
                    setLänderkürzel(element.address.countryCode);
                    setState(element.address.state);
                    setCity(element.address.city);
                    setTel(element.phone);
                }
            } else {
                setCompanyNameFirma('');
                setKontaktName('');
                setPLZ('');
                setStreetAndNr('');
                setAdresszusatz('');
                setLänderkürzel('');
                setState('');
                setCity('');
                setTel('');
            }
        })
    }

    const [namesInfo, setNamesInfo] = useState()
    const namesOptions = []
    const [createableNamesOptions, setCreateAbleNamesOptions] = useState()
    const getBusinessSellerNames = async () => {
        try {
            const response = await fetch(
                "/api/customers/dealers/",
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            const payload = await response.json();
            setNamesInfo(payload);
            console.log(payload)
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
            if (response.ok) {
                payload.forEach((element, index) => {
                    var sellerNameTemp = element.companyName + ' / ' + element.firstName + ' ' + element.lastName
                    namesOptions.push({ value: index, label: sellerNameTemp })
                });
                setCreateAbleNamesOptions(namesOptions)
            }
        } catch (e) {
            console.log(e);
        }
    };
    /*eslint-disable */
    useEffect(() => {
        getBusinessSellerNames();
    }, [])
    /*eslint-enable */
    //const handleKeyPress = (event) => {
    //   if(event.key === '+'){
    //     event.preventDefault();
    //}
    //}
    return (
        <div className='mr-5'>
            <div className='input'>
                <Creatable
                    className='mt-3 mb-3'
                    isClearable
                    //isMulti
                    onChange={(value) => handleNameChange(value)}
                    options={createableNamesOptions}
                    value={nameValue}
                    styles={customStyles}
                    placeholder='Find and select Firma/Name or fill up the fields with new values'
                />
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Name/Firma:
                    </InputGroupText>

                    <Input
                        required
                        value={companyNameFirma}
                        onChange={(e) => { setCompanyNameFirma(e.target.value) }}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Kontaktname:
                    </InputGroupText>
                    <Input
                        value={kontaktName}
                        onChange={(e) => { setKontaktName(e.target.value) }}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        PLZ:
                    </InputGroupText>
                    <Input
                        required
                        value={plz}
                        onChange={e => { setPLZ(e.target.value); console.log(plz) }}
                    />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Straße + Nr.:
                    </InputGroupText>
                    <Input
                        required
                        maxLength="30"
                        value={streetAndNr || ''}
                        onChange={e => { setStreetAndNr(e.target.value) }}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Adresszusatz:
                    </InputGroupText>
                    <Input
                        maxLength="30"
                        value={adresszusatz || ''}
                        onChange={e => { setAdresszusatz(e.target.value); console.log(adresszusatz) }}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        Länderkürzel:
                    </InputGroupText>
                    <Input
                        required
                        value={länderkürzel}
                        onChange={e => { setLänderkürzel(e.target.value.toUpperCase()) }}
                        maxLength="2"
                    />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Provinzcode:
                    </InputGroupText>
                    <Input
                        maxLength="5"
                        value={state || ''}
                        onChange={e => { setState(e.target.value) }}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Stadt:
                    </InputGroupText>
                    <Input
                        required
                        value={city}
                        onChange={e => { setCity(e.target.value) }}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        Telefon:
                    </InputGroupText>
                    <Input
                        type="text"
                        onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        // pattern="[0-9]*"
                        //type="number"
                        required
                        value={tel || ''}
                        //onKeyDown="return event.keyCode !== 69"
                        //onKeyDown ={(e) => { if (e.keyCode == 187) { return 0}}}
                        //onKeyPress={handleKeyPress}
                        onChange={e => { setTel(e.target.value) }}
                    />
                </InputGroup>
            </div>
        </div>
    )
}

export default AdresWithList